import { env } from '$env/dynamic/public';

export function isHrefExternal(href: string) {
  if (href.startsWith('https://block.xyz')) {
    return false;
  } else if (
    href.startsWith('https://') ||
    href.startsWith('http://') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:')
  ) {
    return true;
  } else {
    return false;
  }
}

export function isHref(href: string) {
  if (href.startsWith('https://') || href.startsWith('http://')) {
    return true;
  } else {
    return false;
  }
}

export function isDocumenHref(href: string) {
  const url = new URL(href, env.PUBLIC_BASE_URL);

  return url.origin === env.PUBLIC_BASE_URL && url.pathname.startsWith('/documents/');
}
